import { getAnalytics, logEvent, setUserId } from 'firebase/analytics';

let analytics: ReturnType<typeof getAnalytics> | null = null;

export function initAnalytics(firebaseApp: any) {
  if (import.meta.env.PROD) {
    try {
      analytics = getAnalytics(firebaseApp);
      console.info('Firebase Analytics initialized');
    } catch (error) {
      console.error('Failed to initialize Firebase Analytics:', error);
    }
  } else {
    console.info('Firebase Analytics disabled in development mode');
  }
}

export function trackEvent(eventName: string, params?: Record<string, any>) {
  if (analytics && import.meta.env.PROD) {
    logEvent(analytics, eventName, params);
  } else if (import.meta.env.DEV) {
    console.info('[Analytics]', eventName, params);
  }
}

export function trackPageView(pageName: string) {
  trackEvent('page_view', {
    page_name: pageName,
    page_path: window.location.pathname,
  });
}

export function trackLessonStart(lessonId: string) {
  trackEvent('lesson_start', { lesson_id: lessonId });
}

export function trackLessonComplete(lessonId: string, duration: number) {
  trackEvent('lesson_complete', {
    lesson_id: lessonId,
    duration_seconds: duration,
  });
}

export function trackQuizAnswer(
  lessonId: string,
  questionId: string,
  correct: boolean
) {
  trackEvent('quiz_answer', {
    lesson_id: lessonId,
    question_id: questionId,
    correct,
  });
}

export function trackUserSignup(method: string) {
  trackEvent('sign_up', { method });
}

export function trackUserLogin(method: string) {
  trackEvent('login', { method });
}

export function setAnalyticsUser(userId: string) {
  if (analytics && import.meta.env.PROD) {
    setUserId(analytics, userId);
  }
}
